import { render, staticRenderFns } from "./RsaPazienteAreeComponent.vue?vue&type=template&id=06cdaff1"
import script from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports